module.exports = __webpack_public_path__ + "img/dbds.f4c54767.png";